 
import { Card, Divider, Typography } from '@mui/material';
 
import React, { useState } from 'react'
import Map, { Marker, Popup } from 'react-map-gl';
 

function DirectoryMap({list}) {
    console.log(list)
    const [marker, setMarker] = useState({lat: -15.41597580613962, lng : 28.28086405733302})
   
 return (
   <div  >
     
 <Map
     mapboxAccessToken="pk.eyJ1IjoiY2hpc29tbyIsImEiOiJjbG1oZG43MzQxdmo4M3FxcWNyamJuazg1In0.Qzx7VHsNIxxh-knHPliPWw"
     initialViewState={{
       longitude: marker.lng,
       latitude: marker.lat,
       zoom: 14
     }}
   
     style={{width: "100%", height:"80vh"}}
     mapStyle="mapbox://styles/mapbox/streets-v9"
   >
 {list.map((l, index) => {
  if (l.location && l.location.lat !== undefined && l.location.long !== undefined) {
    return (
          <Marker
     longitude={l.location.long}
    key={index}
   anchor='bottom'
     latitude={l.location.lat}
   color="red"
   
     onClick={()=>console.log(l)}
  ><Card sx={{p:1, width:150}}>
  <Typography sx={{fontSize:16}}>{l.name}<br/>
  <Typography component={"span"} sx={{fontSize:14}}>{l.address}</Typography></Typography>
  <img src={l.cover_image} width="100%" alt={l.name} />
 </Card>
  </Marker>
     
    );
  }
  return null; 
})}
     </Map>
    
         </div>
 )
}

export default DirectoryMap